import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesCustomFieldsManageRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-custom-fields-manage',
	path: '/secure/admin/ManageConfigurationScheme!default.jspa',
};
